import { ReactNode } from 'react';
import { mdgTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={mdgTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
